/**
 * Decrease menu-size on scroll
 */
const menu = document.querySelector('.site-header');
document.addEventListener('scroll', () => {
    // use document.documentElement for chrome, firefox, ie or opera
    // and document.body for safari since that's where overflow is set in those browsers
    if (document.documentElement.scrollTop > 0) menu.classList.add('--scrolled');
    else menu.classList.remove('--scrolled');
});

/**
 * Hide scroll to options if on ContentPage
 */
if (!document.body.contains(document.body.querySelector('.site-footer'))) {
    const siteNav = document.querySelector('.site-header__nav') as HTMLElement;
    siteNav.style.display = "none";
}

/**
 * GSAP scroll animation
 * - All <section/> tags gets GSAP-animation when the scroll hits their area.
 */
import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// Due to certain iPhone verisons not fully supports GSAP after all these years I decided to deactivate it from mobile.
if (window.innerWidth >= 900) {
    const sections = gsap.utils.toArray('section');
    sections.forEach((section) => {
        gsap.set(section, { y: 100, opacity: 0 });
        ScrollTrigger.create({
            trigger: section,
            start: 'top bottom-=100',
            end: () => `+=${section.clientHeight}`,
            markers: false,
            onEnter: () => {
                section.classList.add('in-view');
                gsap.to(section, { y: 0, opacity: 1 });
            },
        })
    })
}

